var _rect, _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeasure(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 67,
    viewBox: "0 0 66 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0117188,
    width: 66,
    height: 66,
    rx: 33,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2733_7948)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2733_7948",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.0039 17.0117H17.0039V49.0117H49.0039V17.0117Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2733_7948)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4039 22.1317V17.0117H22.1239L17.0039 17.0117L17.0039 20.6321L17.0039 22.1317V31.4117H22.1239V25.7521L27.105 30.7332L29.3835 33.0117L27.105 35.2903L22.1239 40.2714V34.6117H17.0039L17.0039 43.8917L17.0039 49.0117H20.6243H22.1239H31.4039V43.8917H25.7443L30.7254 38.9106L33.0039 36.632L35.2825 38.9106L40.2636 43.8917H34.6039V49.0117H43.8839H49.0039V45.3914V43.8917V34.6117H43.8839V40.2714L38.9028 35.2903L36.6242 33.0117L38.9028 30.7332L43.8839 25.7521V31.4117H49.0039V22.1317V17.0117L45.3836 17.0117L43.8839 17.0117L34.6039 17.0117V22.1317H40.2636L35.2825 27.1128L33.0039 29.3913L30.7254 27.1128L25.7443 22.1317H31.4039Z",
    fill: "#14705F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2733_7948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(17 17.0117)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasure);
export default __webpack_public_path__ + "static/media/measure.611df3a11286173c66d9675812812275.svg";
export { ForwardRef as ReactComponent };